module.exports = __webpack_public_path__ + "img/Construction-Supply-Chain-Collaboration-web.b2f08e84.png";